export default from './VideoPlayer';



// WEBPACK FOOTER //
// ./src/sharedComponents/VideoPlayer/index.js